import swal from "sweetalert";
import { post } from "../../helpers/api_helper";
import { toast } from "react-toastify";

export const ActiveInactive_Record = (
  currentStatus,
  apiUrl,
  payload,
  setIsLoading,
  fnCallback,
  customText,
) => {
  swal({
    title: `Are you sure you want to ${
      currentStatus == true ? "inactive" : "active"
    } the record?`,
    text: customText ?? "",
    icon: "warning",
    buttons: true,
    dangerMode: true,
    //buttons: ["No", "Yes"],
    buttons: {
      cancel: {
        text: "No",
        value: false,
        visible: true,
        className: "btn-sm",
      },
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "btn-sm",
        closeModal: true,
      },
    },
    closeOnClickOutside: false,
  }).then((confirmResult) => {
    if (confirmResult) {
      ActiveInactive_RecordConfirm(
        currentStatus,
        apiUrl,
        payload,
        setIsLoading,
        fnCallback,
      );
    }
  });
};

const ActiveInactive_RecordConfirm = async (
  currentStatus,
  apiUrl,
  payload,
  setIsLoading,
  fnCallback,
) => {
  setIsLoading(true);
  await post(apiUrl, payload)
    .then((response) => {
      if (response.IsSuccess) {
        // swal({
        //   title: currentStatus == true ? "Inactivated" : "Activated",
        //   text:
        //     currentStatus == true
        //       ? "Record has been Inactivated."
        //       : "Record has been Activated.",
        //   icon: "success",
        //   button: "OK",
        // });
        successMessage(
          currentStatus == true
            ? "Record has been Inactivated."
            : "Record has been Activated.",
        );
        setIsLoading(false);
        fnCallback();
      } else {
        //swal("Error!", response.Message, "error");
        errorMessage(response.Message);
        setIsLoading(false);
      }
    })
    .catch((error) => {
      console.log(error);
      setIsLoading(false);
    });
};

export const delete_Record = (
  apiUrl,
  payload,
  setIsLoading,
  fnCallback,
  customText,
) => {
  swal({
    title: "Are you sure you want to delete the record?",
    text: customText ?? "You won't be able to revert this!",
    icon: "warning",
    buttons: true,
    dangerMode: true,
    //buttons: ["No", "Yes"],
    buttons: {
      cancel: {
        text: "No",
        value: false,
        visible: true,
        className: "btn-sm",
      },
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "btn-sm",
        closeModal: true,
      },
    },
    closeOnClickOutside: false,
  }).then((willDelete) => {
    if (willDelete) {
      delete_RecordConfirm(apiUrl, payload, setIsLoading, fnCallback);
    }
  });
};

const delete_RecordConfirm = async (
  apiUrl,
  payload,
  setIsLoading,
  fnCallback,
) => {
  setIsLoading(true);
  await post(apiUrl, payload)
    .then((response) => {
      if (response.IsSuccess) {
        // swal({
        //   title: "Deleted",
        //   text: "Record has been deleted.",
        //   icon: "success",
        //   button: "OK",
        // });
        successMessage("Record has been deleted.");
        setIsLoading(false);
        fnCallback();
      } else {
        //swal("Error!", response.Message, "error");
        errorMessage(response.Message);
        setIsLoading(false);
      }
    })
    .catch((error) => {
      console.log(error);
      setIsLoading(false);
    });
};

export const successMessage = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
  });
};

export const errorMessage = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const warningMessage = (message) => {
  toast.warn(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const infoMessage = (message) => {
  toast.info(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

/* to clean comma(,) separated value string like remove empty and also options to removeDuplicates */
export const cleanCsvString = (str, removeDuplicates = true) => {
  // default to true
  removeDuplicates = removeDuplicates === undefined ? true : removeDuplicates;

  // go through each item
  return String(str)
    .split(",")
    .map(function (item) {
      // trim value
      return String(item).trim();
    })
    .filter(function (item, index, all) {
      if (removeDuplicates) {
        // remove empty items & duplicate values
        return item !== "" && index === all.indexOf(item);
      }

      return item;
    })
    .join(",");
};

/* validate email string, returns null if invalid email */
export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

/* validate email string, returns error if invalid email - used for formik field ex. <Field validate={validateEmailField} /> */
export const validateEmailField = (value) => {
  let error;
  if (!value) {
    error = "";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
    error = "Please enter a valid email address";
  }
  return error;
};

export const validateMobileNoField = (format, countryCode, value) => {
  let isValid = true;
  if (value && format) {
    if (
      String(format).replace(/[- ]/g, "") !==
      String(`+${countryCode.replace(/\+/g, "")}${value}`).replace(
        /[0-9]/g,
        ".",
      )
    ) {
      isValid = false;
    }
  }
  return isValid;
};

/*handle Key Down to prevent Form submit on Enter key press */
export const handleKeyDownForm = (event) => {
  const { key, target } = event;
  if (
    key === "Enter" &&
    target.type !== "submit" &&
    target.tagName.toLowerCase() !== "textarea"
  ) {
    event.preventDefault(); // Prevents the default behavior for the enter key
  }
};

export const delete_RecordWithoutApi = (
  fnCallback,
  index = -1,
  subIndex = -1,
  id = 0,
) => {
  swal({
    title: "Are you sure you want to delete the record?",
    text: "It will be affected after submit the form",
    icon: "warning",
    buttons: true,
    dangerMode: true,
    //buttons: ["No", "Yes"],
    buttons: {
      cancel: {
        text: "No",
        value: false,
        visible: true,
        className: "btn-sm",
      },
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "btn-sm",
        closeModal: true,
      },
    },
    closeOnClickOutside: false,
  }).then((willDelete) => {
    if (willDelete) {
      fnCallback(index, subIndex, id);
    }
  });
};

export const customConfirmDialog = (
  titleString,
  textString,
  fnCallback,
  callBackResultValue = false,
) => {
  swal({
    title: titleString,
    text: textString,
    icon: "warning",
    buttons: true,
    dangerMode: true,
    //buttons: ["No", "Yes"],
    buttons: {
      cancel: {
        text: "No",
        value: false,
        visible: true,
        className: "btn-sm",
      },
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "btn-sm",
        closeModal: true,
      },
    },
    closeOnClickOutside: false,
  }).then((willDo) => {
    if (willDo == callBackResultValue) {
      fnCallback();
    }
  });
};

// export const capitalizeString = (e) => {
//   const value = e?.target?.value ?? "";
//   const capitalizeValue = value
//     ? value.charAt(0).toUpperCase() + value.slice(1)
//     : "";

//   return capitalizeValue;
// };

export const capitalizeString = (value) => {
  const capitalizeValue = value
    ? value.charAt(0).toUpperCase() + value.slice(1)
    : "";

  return capitalizeValue;
};

export const convertTimeToDateTime = (time) => {
  const currentDate = new Date();
  const [hours, minutes] = time.split(":").map(Number);
  currentDate.setHours(hours);
  currentDate.setMinutes(minutes);

  return currentDate;
};
